// new-chatbot-components/ClientOnlyErrorBoundary.tsx
'use client'

import React, { ReactNode, useEffect } from 'react'
import ErrorBoundary from '@/services/ErrorBoundary'
import Fallback from '@/services/fallback'
import { useAuth } from '@clerk/nextjs'
import * as Sentry from '@sentry/nextjs'
import { useUser } from '@clerk/nextjs'
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store'
interface ClientOnlyErrorBoundaryProps {
  children: ReactNode
}

const ClientOnlyErrorBoundary = ({
  children
}: ClientOnlyErrorBoundaryProps) => {
  const { userId } = useAuth()
  const { user: clerkUser } = useUser()
  const mixusUser = useUserStore(state => state.user)
  useEffect(() => {
    const user = {
      id: mixusUser?._id || clerkUser?.id || undefined,
      username: mixusUser?.username || clerkUser?.username || undefined,
      email: clerkUser?.emailAddresses?.[0]?.emailAddress || undefined
    }
    Sentry.setUser(user)
  }, [])
  return (
    <ErrorBoundary userId={userId || 'guest'} fallback={<Fallback />}>
      {children}
    </ErrorBoundary>
  )
}

export default ClientOnlyErrorBoundary
